/**
 * Art Product Breadcrumbs Component
 *
 * Listens for variant changes and updates the breadcrumbs dynamically
 * when a variant with a different art_product is selected.
 */

import { ThemeEvents } from '@theme/events';

class ArtProductBreadcrumbs extends HTMLElement {
  connectedCallback() {
    // Listen for variant update events
    document.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate.bind(this));
  }

  /**
   * Handles variant update events from the native variant picker
   * @param {CustomEvent} event - The variant update event
   */
  handleVariantUpdate(event) {
    const { html } = event.detail.data;

    if (!html) return;

    // Find the updated breadcrumbs in the new HTML
    const newBreadcrumbs = html.querySelector('art-product-breadcrumbs');

    if (!newBreadcrumbs) {
      // If no breadcrumbs in the new HTML, hide this element
      this.style.display = 'none';
      return;
    }

    // Check if breadcrumbs should be shown (has content)
    const hasContent = newBreadcrumbs.querySelector('.art-product-breadcrumbs');

    if (hasContent) {
      // Replace the inner HTML with the new breadcrumbs
      this.innerHTML = newBreadcrumbs.innerHTML;
      this.style.display = '';
    } else {
      // Hide if new variant doesn't have art_product
      this.style.display = 'none';
    }
  }
}

if (!customElements.get('art-product-breadcrumbs')) {
  customElements.define('art-product-breadcrumbs', ArtProductBreadcrumbs);
}
